import * as GroupType from 'constants/GroupType';

export default {0: GroupType.DEFAULT_GROUP};


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Boxing/GroupMap.js